import styled from 'shared/utils/styled';

export const StyledTitle = styled('h1')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontSize: theme.typography.pxToRem(28),
  fontWeight: 600,
  color: theme.palette.primary.main,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.pxToRem(21),
  },
}));
